import { DragHandleRule } from '@tiptap/extension-drag-handle';

/**
 * accordionPanel nodes are never drag targets themselves
 */
const excludeAccordionPanel: DragHandleRule = {
  id: 'excludeAccordionPanel',
  evaluate: ({ node }) => {
    return node.type.name === 'accordionPanel' ? 1000 : 0;
  },
};

/**
 * When inside an accordionPanel, exclude the parent accordion from being the drag target.
 * Only child blocks within the panel should be draggable from there.
 * The accordion-level drag handle appears when hovering over the "Add panel" button.
 */
const excludeAccordionWhenInsidePanel: DragHandleRule = {
  id: 'excludeAccordionWhenInsidePanel',
  evaluate: ({ node, $pos, depth }) => {
    if (node.type.name !== 'accordion') return 0;

    for (let d = $pos.depth; d > depth; d--) {
      if ($pos.node(d).type.name === 'accordionPanel') {
        return 1000;
      }
    }

    return 0;
  },
};

export const ACCORDION_DRAG_RULES: DragHandleRule[] = [excludeAccordionPanel, excludeAccordionWhenInsidePanel];
